import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopuneinnovacrysta() {



const cardData = {
  keyword: " Mumbai to Pune Innova Crysta Cab",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Pune Innova Crysta cab services, ensuring a premium and spacious travel experience for families, business travelers, and group trips. Our well-maintained Innova Crysta vehicles offer comfortable seating, ample luggage space, and smooth suspension for long-distance travel. The journey from Mumbai to Pune covers around 150 km via the Mumbai–Pune Expressway and usually takes about 3 to 3.5 hours depending on traffic. :contentReference[oaicite:0]{index=0} Velocity Cab offers flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. With professional drivers, punctual pickups, easy online booking, and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Pune Innova Crysta cab travel.",

topPlaces: [
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is one of Pune’s most important historical landmarks, known for its role in India’s freedom movement. Travelers booking a sedan cab in Pune can explore its elegant architecture, peaceful gardens, and museum dedicated to Mahatma Gandhi, making it a must-visit cultural and heritage site."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is a famous spiritual destination in Pune dedicated to Lord Ganesha. Visitors can experience divine blessings, admire the beautifully decorated idol, and enjoy the vibrant atmosphere, especially during Ganesh Chaturthi celebrations."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases an extensive collection of Indian artifacts, including sculptures, musical instruments, and traditional objects. It offers visitors a deep insight into India’s cultural heritage and artistic excellence."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a historic landmark in Pune offering panoramic views of the city from its hilltop temples. Travelers can climb the steps to explore ancient shrines and enjoy a peaceful environment surrounded by natural beauty."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a beautifully designed Japanese-style garden featuring serene landscapes, water streams, and walking paths. It is a perfect place for relaxation, photography, and nature walks."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. Its peaceful surroundings and historic architecture make it a unique spiritual and heritage site in Pune."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification that once served as the seat of the Peshwas of the Maratha Empire. Visitors can explore its grand gates, ruins, and enjoy the evening light and sound show that narrates Pune’s royal history."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular garden in Pune known for its lush greenery and the Siddhivinayak Temple located inside it. It is a peaceful spot for families, morning walkers, and visitors looking for relaxation in the city."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a scenic riverside park offering boating facilities, green lawns, and walking tracks. It is a great place for relaxation and leisure activities in the heart of Pune."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a major shopping and entertainment hub featuring top brands, restaurants, cinemas, and entertainment zones. It is a popular destination for shopping and leisure activities."
  }
],



services: [
{
name: "Mumbai to Pune Innova Crysta Cab Booking",
description: "Mumbai to Pune Innova Crysta cab booking offers premium SUV travel for passengers seeking comfort, space, and reliability on intercity journeys. The Toyota Innova Crysta is one of the most preferred vehicles for long-distance travel due to its superior suspension, spacious seating, and smooth highway performance. Travelers can book this service from any location in Mumbai including airport, railway stations, hotels, and residential areas. Professional drivers ensure safe driving via the Mumbai–Pune Expressway with timely pickups and drop-offs. This service is ideal for corporate executives, families, and group travelers who prioritize comfort. Online booking ensures instant confirmation, transparent pricing, and flexible travel schedules."
},
{
name: "Mumbai Airport to Pune Innova",
description: "Mumbai Airport to Pune Innova cab service provides reliable airport transfer for passengers arriving at domestic or international terminals. Travelers can enjoy comfortable rides in spacious Innova vehicles with ample luggage space. Professional drivers monitor flight timings and provide punctual pickups directly from the airport. Smooth expressway travel ensures quick and safe arrival in Pune. This service is widely used by corporate travelers and families arriving in Mumbai."
},
{
name: "Pune to Mumbai Airport One Way Innova Cab",
description: "Pune to Mumbai Airport one way Innova cab service offers economical travel for passengers heading to Mumbai airport. Travelers can enjoy premium SUV comfort without paying for return fare. The Innova Crysta ensures spacious seating, smooth ride quality, and excellent highway performance. Professional drivers provide punctual pickups from Pune homes, offices, and hotels ensuring timely airport drop."
},
{
name: "Mumbai Airport to Koregaon Park Innova Cab",
description: "Mumbai Airport to Koregaon Park Innova cab service offers premium transportation between Mumbai airport and Koregaon Park in Pune. Travelers can enjoy comfortable long-distance travel with spacious seating and air-conditioned interiors. Professional drivers ensure safe highway driving and timely pickups from airport terminals. This service is popular among business travelers and tourists visiting Koregaon Park."
},
{
name: "Mumbai Airport to Viman Nagar Innova Cab",
description: "Mumbai Airport to Viman Nagar Innova cab service provides reliable transportation for passengers traveling to Pune’s Viman Nagar area. Comfortable Innova vehicles ensure smooth expressway travel with ample space for luggage. Professional drivers offer punctual airport pickup and safe driving throughout the journey."
},
{
name: "Mumbai Airport to Kothrud Innova Car Fare",
description: "Mumbai Airport to Kothrud Innova cab service offers convenient travel between Mumbai airport and Kothrud in Pune. Travelers can enjoy comfortable long-distance journeys in premium SUV vehicles. Professional drivers ensure safe expressway travel and timely pickups from airport terminals. Transparent pricing helps travelers plan their journey easily."
},
{
name: "Mumbai Airport to Pune Station Innova Cab",
description: "Mumbai Airport to Pune station Innova cab service provides dependable transportation for passengers traveling to Pune Railway Station. Comfortable Innova vehicles ensure smooth highway travel while professional drivers provide punctual airport pickups. This service is ideal for passengers connecting train journeys after arriving in Mumbai."
},
{
name: "Innova Crysta on Rent Mumbai Airport",
description: "Innova Crysta on rent at Mumbai airport offers premium SUV transportation for airport transfers and outstation travel. Travelers can book spacious vehicles with experienced drivers for comfortable journeys to Pune and other destinations. This service ensures timely pickups, smooth travel, and high comfort levels."
},
{
name: "Innova Hire in Mumbai",
description: "Innova hire in Mumbai provides premium SUV travel for city rides, airport transfers, and outstation trips. Travelers can book well-maintained vehicles with professional drivers for safe and comfortable journeys. This service is ideal for family trips, corporate travel, and group travel."
},
{
name: "Innova Per Km Rate in Mumbai",
description: "Innova per km rate in Mumbai offers transparent pricing for outstation travel including trips to Pune. Travelers can calculate their travel cost based on distance, vehicle type, and trip duration. Clear pricing ensures better budget planning for long-distance journeys."
},
{
name: "Innova Crysta on Rent in Mumbai",
description: "Innova Crysta on rent in Mumbai provides premium SUV travel for passengers seeking luxury and comfort. The vehicle offers spacious seating, powerful performance, and smooth ride quality for both city and highway travel. Professional drivers ensure safe journeys for airport transfers and outstation trips."
},
{
name: "Innova Car Rent Per Day in Mumbai",
description: "Innova car rent per day in Mumbai offers flexible rental options for passengers requiring full-day travel. Travelers can use this service for city tours, corporate travel, and outstation trips to Pune. Comfortable vehicles and professional drivers ensure a convenient travel experience."
},
{
name: "Book Innova Crysta Cabs in Mumbai",
description: "Book Innova Crysta cabs in Mumbai for premium travel experience with comfortable seating and reliable service. Travelers can easily reserve vehicles online for airport transfers and long-distance journeys to Pune with instant confirmation and transparent pricing."
},
{
name: "Innova Crysta Car Hire Mumbai",
description: "Innova Crysta car hire in Mumbai provides luxury SUV travel for passengers seeking comfort and convenience. The vehicle is ideal for long-distance trips to Pune with spacious interiors and smooth ride quality. Professional drivers ensure safe and timely travel."
},
{
name: "Mumbai to Pune Innova Crysta Cab",
description: "Mumbai to Pune Innova Crysta cab service offers premium long-distance travel between the two cities. Travelers can enjoy smooth expressway journeys with spacious seating and excellent ride comfort. Professional drivers provide safe driving and punctual pickups from Mumbai locations."
},
{
name: "Mumbai to Pune Innova Cab",
description: "Mumbai to Pune Innova cab service provides reliable transportation with comfortable SUV vehicles ideal for families and groups. Travelers benefit from smooth highway travel, spacious seating, and professional drivers ensuring safe journeys."
},
{
name: "Innova Crysta Cab Mumbai to Pune",
description: "Innova Crysta cab Mumbai to Pune offers premium SUV travel for passengers seeking comfort and convenience. The vehicle ensures smooth expressway travel with spacious interiors and modern features."
},
{
name: "Mumbai to Pune Innova Taxi",
description: "Mumbai to Pune Innova taxi service provides convenient long-distance transportation with comfortable vehicles and experienced drivers ensuring safe highway travel."
},
{
name: "Mumbai to Pune Innova Crysta Taxi",
description: "Mumbai to Pune Innova Crysta taxi service offers luxury SUV travel for passengers seeking comfort, safety, and reliability during intercity journeys."
},
{
name: "Mumbai to Pune Innova Cab Service",
description: "Mumbai to Pune Innova cab service offers dependable transportation with spacious vehicles and professional drivers ensuring safe and comfortable journeys."
},
{
name: "Mumbai to Pune Innova Crysta One Way Cab",
description: "Mumbai to Pune Innova Crysta one way cab service offers economical travel for passengers needing single-direction transportation with premium SUV comfort."
},
{
name: "Mumbai to Pune Innova Crysta Taxi Booking",
description: "Mumbai to Pune Innova Crysta taxi booking allows passengers to easily reserve premium SUV taxis online with instant confirmation and transparent pricing."
},
{
name: "Mumbai to Pune Innova Crysta Drop Taxi",
description: "Mumbai to Pune Innova Crysta drop taxi service offers convenient one-way transportation with luxury vehicles and affordable pricing."
}
],

tableData: [
["Mumbai to Pune Innova Crysta Cab Booking","Mumbai Airport to Pune Innova"],
["Pune to Mumbai Airport One Way Innova Cab","Mumbai Airport to Koregaon Park Innova Cab"],
["Mumbai Airport to Viman Nagar Innova Cab","Mumbai Airport to Kothrud Innova Car Fare"],
["Mumbai Airport to Pune Station Innova Cab","Innova Crysta on Rent Mumbai Airport"],
["Innova Hire in Mumbai","Innova Per Km Rate in Mumbai"],
["Innova Crysta on Rent in Mumbai","Innova Car Rent Per Day in Mumbai"],
["Book Innova Crysta Cabs in Mumbai","Innova Crysta Car Hire Mumbai"],
["Mumbai to Pune Innova Crysta Cab","Mumbai to Pune Innova Cab"],
["Innova Crysta Cab Mumbai to Pune","Mumbai to Pune Innova Taxi"],
["Mumbai to Pune Innova Crysta Taxi","Mumbai to Pune Innova Cab Service"],
["Mumbai to Pune Innova Crysta One Way Cab","Mumbai to Pune Innova Crysta Taxi Booking"],
["Mumbai to Pune Innova Crysta Drop Taxi","Mumbai to Pune Innova Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Premium Innova Crysta Experience",
    WhyChoosedescription: "Velocity Cabs offers luxury Innova Crysta cabs for Mumbai to Pune travel, providing superior comfort, spacious seating, and a smooth ride ideal for long-distance journeys."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Mumbai to Pune travel via the Mumbai Pune Expressway. Their expertise ensures safe driving, timely arrival, and a stress-free journey."
  },
  {
    WhyChooseheading: "Transparent Premium Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent pricing for Innova Crysta bookings. Customers receive complete fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Innova Crysta Availability",
    WhyChoosedescription: "Our Mumbai to Pune Innova Crysta cab service operates 24/7. Whether for business travel, airport transfers, or family trips, we ensure availability anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Innova Crysta vehicles are fully air-conditioned, sanitized, and regularly maintained to provide a premium and comfortable travel experience."
  },
  {
    WhyChooseheading: "Ideal for Family & Corporate Travel",
    WhyChoosedescription: "Innova Crysta is perfect for families, corporate travelers, and group travel with ample space for luggage and comfortable seating for long-distance journeys."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible booking options including one-way cab service, round-trip travel, and customized travel plans from Mumbai to Pune."
  },
  {
    WhyChooseheading: "Trusted Premium Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Pune Innova Crysta cab bookings thanks to luxury vehicles, professional drivers, and reliable intercity service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Pune Innova Crysta cab service?", answer: "Yes, Velocity Cabs provides premium Innova Crysta cab services from Mumbai to Pune for comfortable and luxury travel." },
  { question: "Is Innova Crysta suitable for long-distance travel?", answer: "Yes, Innova Crysta is ideal for long-distance journeys like Mumbai to Pune due to its comfort, space, and smooth performance." },
  { question: "Is Mumbai to Pune Innova Crysta cab available 24 hours?", answer: "Yes, our Innova Crysta cab service operates 24/7 for customer convenience." },
  { question: "How many passengers can travel in Innova Crysta?", answer: "Innova Crysta can comfortably accommodate 6 to 7 passengers along with luggage." },
  { question: "Can I book a one-way Innova Crysta cab?", answer: "Yes, we provide both one-way and round-trip Innova Crysta cab services between Mumbai and Pune." },
  { question: "Do you provide airport pickup and drop?", answer: "Yes, Velocity Cabs provides airport pickup and drop services for Mumbai Airport and Pune Airport." },
  { question: "Are Innova Crysta vehicles air-conditioned?", answer: "Yes, all Innova Crysta vehicles are fully air-conditioned and well maintained." },
  { question: "Can I book the Innova Crysta cab online?", answer: "Yes, customers can easily book Mumbai to Pune Innova Crysta cab services online or via phone booking." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and peak travel seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Mehta",
    feedback:
      "Highway travel from Mumbai to Pune felt very smooth and comfortable. The cab was punctual, clean, and the entire ride was handled in a professional way.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback:
      "The Mumbai to Pune journey was hassle-free and well-organized. The vehicle was comfortable, and the drive remained safe and steady throughout.",
    rating: 5
  }
];


































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Innova Crysta Cab | Velocity Cabs",
  "description": "Book Mumbai to Pune Innova Crysta cab with Velocity Cabs. Available from Mumbai Airport to Pune Station, Koregaon Park, Viman Nagar, Kothrud. One-way, round trip & airport transfers.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1620"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Mumbai to Pune Innova Crysta Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book Mumbai to Pune Innova Crysta cab with Velocity Cabs. Airport to Koregaon Park, Viman Nagar, Kothrud & Pune Station. One-way, round trip & outstation services available."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/57.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopuneinnovacrysta;